import { GetUserWatchlistsParams, GetUserWatchlistsResponse, WatchlistClientParams, WatchlistResponse } from "./types";

export default class WatchlistClient {

    watchlistServiceUrl: string;

    constructor({ watchlistServiceUrl }: WatchlistClientParams) {
        this.watchlistServiceUrl = watchlistServiceUrl;
    }

    getUserWatchlists(
        { bconnectId, userToken: userKey }: GetUserWatchlistsParams
    ): Promise<WatchlistResponse<GetUserWatchlistsResponse>> {
        const headers = userKey !== undefined ? {
            userKey
        } : undefined;

        const url = new URL(`${ this.watchlistServiceUrl }/get/${ bconnectId }`);

        return this.#fetchJSON<GetUserWatchlistsResponse>(url, {
            method: "GET",
            credentials: "include",
            headers
        });
    }

    #fetchJSON<D>(
        ...args: Parameters<typeof fetch>
    ): Promise<{ data?: D | string; status: number; message: string; }> {
        const [url, params] = args;

        return (
            fetch(url, params)
                .then(async (response) => {
                    const { status, ok, statusText: message } = response;
                    const clone = response.clone();
                    const data: D | string | undefined = await response.json().catch(
                        () => clone.text()
                    );

                    return (ok
                        ? Promise.resolve({ status, data, message })
                        : Promise.reject({ status, data, message })
                    );
                })
        );
    }

}
